import { TableRowStyled } from '@styled/table-row.styled';
import JTableCell from '@atoms/JTabelCell';
import moment from 'moment';
import { ActionBoxStyled } from './expenses-list.styled';
import { ActionExpenses } from '@/modules/credits/constants';
import { useTheme } from '@mui/material';
import { IConsumption } from '@/modules/credits/models/consumptions';
import { useTranslation } from 'react-i18next';

interface Props {
  row: IConsumption;
}

const ExpensesRow = ({ row }: Props) => {
  const theme = useTheme();
  const {
    creditConsumption_id: id,
    creditConsumption_created_at: createdAt,
    creditConsumption_credits_amount_consumed: creditsAmountConsumed,
    creditConsumption_consumption_action: action,
    establishment_name: establishmentName,
    establishment_credits_amount_remaining: creditsAmountRemaining,
    enterprise_name: entrepriseName,
    fullname,
  } = row;
  const { t } = useTranslation();

  const bgColor =
    action === ActionExpenses.play_cv_video
      ? theme.palette.primary.main
      : theme.palette.warning.main;

  return (
    <TableRowStyled
      key={id}
      data-test={`user-list-row-${entrepriseName}-${creditsAmountConsumed}-${creditsAmountRemaining}`}
    >
      <JTableCell isbold>{entrepriseName}</JTableCell>
      <JTableCell isbold>{establishmentName}</JTableCell>
      <JTableCell>{fullname}</JTableCell>
      <JTableCell>
        <ActionBoxStyled attrs={{ bgColor }}>
          {t(action.toLocaleUpperCase())}
        </ActionBoxStyled>
      </JTableCell>
      <JTableCell>{creditsAmountConsumed}</JTableCell>
      <JTableCell>{moment(createdAt).format('DD/MM/YYYY')}</JTableCell>
    </TableRowStyled>
  );
};

export default ExpensesRow;
